import axios from 'axios'
import _URL from '../../URL/index';
const limit = 15;

export default {
    services: {
        login: (data) => {
            return axios.post(`${_URL._API}/login`, data);
        },
        validateEmail: (email) => {
            return axios.get(`${_URL._API}/validation/email/${email}`);
        },
        forgotPassword: (email) => {
            return axios.get(`${_URL._API}/forgot/password?email=${email}&client=dispatch`)
        },
        restorePassword: (_id, data, type, token) => {
            return axios.put(`${_URL._API}/restore/password/${_id}?type_user=${type}&token=${token}`, data)
        },
        restoreToken: (userId, role, account) => {
            return axios.post(`${_URL._API}/auth/restore/token`, { userId: userId, role: role, account: account })
        }
    }
}